import { RequestState } from "common/RequestState";

export const isLoading = request => isNotRequested(request) || isInProgress(request);
export const isNotRequested = request =>
  !request || !request.requestState || request.requestState === RequestState.NotRequested;
export const isInProgress = request => request && request.requestState === RequestState.InProgress;
export const isFinished = request => request && request.requestState === RequestState.Finished;
export const isFailed = request => request && request.requestState === RequestState.Failed;
